import cookies from 'js-cookie';
async function getCookies(name) {
    if (name) {
        return cookies.get(name);
    }
    else {
        return cookies.get();
    }
}
export default getCookies;
